module.exports = __webpack_public_path__ + "img/redirect-arrow-rounded-pointer-icon.24f43cc2.svg";